import { ToneDto } from '../tonedto';

export interface PreviewToneDto
{
    getAPartyMsisdn(): string;
    getBPartyMsisdn(): string;
    getToneId(): string;

    getPreviewToneDetail(): ToneDto;
}

export class PreviewToneDtoImpl implements PreviewToneDto
{
    private aPartyMsisdn: string;
    private bPartyMsisdn: string;
    private toneId: string;
    private previewToneDto: ToneDto;

    getAPartyMsisdn(): string 
    {
        return this.aPartyMsisdn;
    }
    setAPartyMsisdn(aPartyMsisdn: string)
    {
        this.aPartyMsisdn = aPartyMsisdn;
    }

    getBPartyMsisdn(): string 
    {
        return this.bPartyMsisdn;
    }
    setBPartyMsisdn(bPartyMsisdn: string)
    {
        this.bPartyMsisdn = bPartyMsisdn;
    }

    getToneId(): string 
    {
        return this.toneId;
    }
    setToneId(toneId: string)
    {
        this.toneId = toneId;
    }

    getPreviewToneDetail(): ToneDto
    {
        return this.previewToneDto;
    }
    setPreviewToneDetail(previewToneDto: ToneDto)
    {
        this.previewToneDto = previewToneDto;
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/dto/previewtone/previewtonedto.tsx